import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';

const ViewChannel = ({channelId}) => {
    const [channelData, setChannelData] = useState(null);

    const fetchChannel = async (Id) => {      
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/channels/${Id}`)
            .then(response => {
                setChannelData(response.data.data);
            })
            .catch(error => {
                console.log(error);
                setChannelData([]); 
            });
    }

    useEffect(() => {
        if (channelId) {
            fetchChannel(channelId);
        }
    },[channelId]);

    if (!channelId || !channelData) {
        return null;
    }

    return (
        <div id={`view_channel_${channelId}`} className="modal custom-modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Channel - {channelData.name} </h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="col-md-12">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">Description</label>
                                    <textarea className="form-control" value={channelData.description} disabled rows={3}/>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewChannel
